import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { 
    Card, 
    Button
} from "antd";
import { WordEditor } from "components";
import "styles/word-editor.css";
import _debounce from "lodash/debounce";
import _noop from "lodash/noop";

class RemarksEditor extends React.Component {
    remarks = this.props.remarks;
    undoRemarks = [this.props.remarks];
    onEdit = _debounce(remarks => {
        this.remarks = remarks;
        this.undoRemarks = [...this.undoRemarks, remarks];
        // this.props.onEdit(this.remarks);
    });

    componentDidMount(){
        this.props.getCaseRemarks && this.props.getCaseRemarks();
    }
    save = () => this.props.onEdit(this.remarks, true);

    undo = () => {
        if(this.undoRemarks.length > 1) {
            this.undoRemarks.pop();
        }
        this.remarks = this.undoRemarks[this.undoRemarks.length - 1];
        this.forceUpdate();
    }

    render() {
        return (
            <Card
                className={"padless-card"}
                style={{minHeight: "443px"}}
                title={"Case Summary"}
                extra={!this.props.readOnly ? [
                    <Button
                        key={"save-button"}
                        type={"link"}
                        onClick={this.save}
                        icon={"save"}
                        disabled={this.props.recreditViewOnlyPermission}
                        loading={this.props.loading || false}
                    >
                        Save
                    </Button>,
                    <Button
                        key={"undo-btn"}
                        type={"link"}
                        onClick={this.undo}
                        icon={"undo"}
                    >
                        Undo
                    </Button>
                    
                ] : null}
            >
                <WordEditor
                    value={this.remarks || this.props.remarks}
                    onEdit={this.onEdit}
                    readOnly={this.props.readOnly}
                    className={cx({
                        "read-only-editor": this.props.readOnly
                    })}
                />
            </Card>
        );
    }
}

RemarksEditor.propTypes = {
    remarks: PropTypes.string,
    readOnly: PropTypes.bool,
    onEdit: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
    loading: PropTypes.bool
};
RemarksEditor.defaultProps = {
    readOnly: false,
    onEdit: _noop
};

export default RemarksEditor;
